import React from 'react'

const CamposCuentaBancaria = ({ state, handleInputChangeEnlace, paisesBancarios, tiposCuenta }) => {
  return (
    <div className="space-y-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
      <h4 className="font-semibold text-blue-800 flex items-center gap-2">
        <i className="fas fa-university"></i>
        Información Bancaria
      </h4>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Nombre del Banco <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <i className="fas fa-university absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            <input
              type="text"
              placeholder="Ej: BBVA, Santander, Banorte"
              value={state.enlace.datosBancarios.nombreBanco}
              onChange={(e) => handleInputChangeEnlace('datosBancarios', {
                ...state.enlace.datosBancarios,
                nombreBanco: e.target.value
              })}
              required
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
        
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            País del Banco
          </label>
          <select
            value={state.enlace.datosBancarios.paisBanco}
            onChange={(e) => handleInputChangeEnlace('datosBancarios', {
              ...state.enlace.datosBancarios,
              paisBanco: e.target.value
            })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            {paisesBancarios.map((pais) => (
              <option key={pais.codigo} value={pais.codigo}>
                {pais.nombre}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Número de Cuenta <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <i className="fas fa-credit-card absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            <input
              type="text"
              placeholder="1234567890"
              value={state.enlace.datosBancarios.numeroCuenta}
              onChange={(e) => handleInputChangeEnlace('datosBancarios', {
                ...state.enlace.datosBancarios,
                numeroCuenta: e.target.value
              })}
              required
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
        
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Tipo de Cuenta
          </label>
          <select
            value={state.enlace.datosBancarios.tipoCuenta}
            onChange={(e) => handleInputChangeEnlace('datosBancarios', {
              ...state.enlace.datosBancarios,
              tipoCuenta: e.target.value
            })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            {tiposCuenta.map((tipo) => (
              <option key={tipo.id} value={tipo.id}>
                {tipo.nombre}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          {paisesBancarios.find(p => p.codigo === state.enlace.datosBancarios.paisBanco)?.campoAdicional || 'Código Adicional'}
        </label>
        <div className="relative">
          <i className="fas fa-hashtag absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
          <input
            type="text"
            placeholder={`Ej: ${paisesBancarios.find(p => p.codigo === state.enlace.datosBancarios.paisBanco)?.campoAdicional || 'Código'}`}
            value={state.enlace.datosBancarios.clabe}
            onChange={(e) => handleInputChangeEnlace('datosBancarios', {
              ...state.enlace.datosBancarios,
              clabe: e.target.value
            })}
            className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Nombre del Titular
        </label>
        <div className="relative">
          <i className="fas fa-user absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
          <input
            type="text"
            placeholder="Nombre completo del titular"
            value={state.enlace.datosBancarios.nombreTitular}
            onChange={(e) => handleInputChangeEnlace('datosBancarios', {
              ...state.enlace.datosBancarios,
              nombreTitular: e.target.value
            })}
            className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Identificación del Titular
        </label>
        <div className="relative">
          <i className="fas fa-id-card absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
          <input
            type="text"
            placeholder="CURP, RFC, DNI, etc."
            value={state.enlace.datosBancarios.identificacionTitular}
            onChange={(e) => handleInputChangeEnlace('datosBancarios', {
              ...state.enlace.datosBancarios,
              identificacionTitular: e.target.value
            })}
            className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>
    </div>
  )
}

export default CamposCuentaBancaria 